import { useEffect } from 'react';
import { logout } from '../api/api';
import { userLoggedOut } from '../slices/users';
import { useAppDispatch } from '../store/hooks';
import { stopCobrowse } from '../utils/Cobrowse';

export default function LogoutContainer() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(userLoggedOut());
    void logout();
    void stopCobrowse();
  }, [dispatch]);

  return null;
}
